import { render, staticRenderFns } from "./CategoryTreeSelectDialog.vue?vue&type=template&id=9115a008&"
import script from "./CategoryTreeSelectDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports